import pathOr from 'ramda/src/pathOr';

import { version } from '../../../package.json';

const playbackAssetDataMap = {
    articleId:          ['id'],
    awayContestantId:   ['contestants', 1, 'id'],
    awayContestantName: ['contestants', 1, 'title'],
    competitionId:      ['competition', 'id'],
    competitionName:    ['competition', 'title'],
    contentId:          ['id'],
    contentName:        ['title'],
    contentType:        ['type', 'name'],
    fixtureId:          ['eventId'],
    homeContestantId:   ['contestants', 0, 'id'],
    homeContestantName: ['contestants', 0, 'title'],
    publicationDate:    ['pubDate'],
    sportId:            ['sport', 'id'],
    sportName:          ['sport', 'title'],
    stageId:            ['stage', 'id'],
    stageName:          ['stage', 'title'],
    venueId:            ['venue', 'id'],
    venueName:          ['venue', 'title'],
};

const playbackMediaDataMap = {
    videoType: ['videoType'],
};

const assetDataMap = {
    expireDate: ['expirationDate'],
};

const configDataMap = {
    commentatoryLanguage:   ['environment', 'language'],
    interfaceLanguage:      ['environment', 'language'],
};

const windowDataMap = {
    applicationType:    ['dazn', 'platform'],
    daznUserAgent:      ['navigator', 'userAgent'],
    countryCode:        ['dazn', 'userProfile', 'UserCountryCode'],
    site:               ['location', 'hostname'],
};

const extractMetadataWithDataMap = (source, dataMap) =>
    Object.keys(dataMap).reduce((acc, key) => {
        acc[key] = pathOr(null, dataMap[key], source) || `Unknown ${key}`;
        return acc;
    }, {});

const getAccountType = authToken => JSON.parse(atob(authToken.split('.')[1])).userstatus;
const getProductionValue = categories => categories.map(e => e.name).join(', ');

const deriveConvivaCustomMetadata = (latestPlayback, latestConfig, latestAsset, window) => {
    const playbackAssetMetadata = extractMetadataWithDataMap(latestPlayback.asset, playbackAssetDataMap);
    const playbackMediaMetadata = extractMetadataWithDataMap(latestPlayback.media, playbackMediaDataMap);
    const assetMetadata         = extractMetadataWithDataMap(latestAsset, assetDataMap);
    const configMetadata        = extractMetadataWithDataMap(latestConfig, configDataMap);
    const windowMetadata        = extractMetadataWithDataMap(window, windowDataMap);

    const metadata = {
        applicationVersion: version,
        autoPlay: 'true', // NB: Conviva requires that all custom meta tags be strings
        accountType: getAccountType(latestConfig.environment.authToken),
        productionValue: getProductionValue(latestPlayback.asset.categories),
    };

    const unknownValues = {
        deviceCarrier: 'Unknown deviceCarrier',
        deviceConnectionType: 'Unknown deviceConnectionType',
    };

    return Object.assign(
        playbackAssetMetadata,
        playbackMediaMetadata,
        assetMetadata,
        configMetadata,
        windowMetadata,
        metadata,
        unknownValues,
    );
};

export {
    deriveConvivaCustomMetadata as default,
    extractMetadataWithDataMap,
    getAccountType,
    getProductionValue,
};
